import React, { FC, ReactNode }       from 'react';
import classNames                                    from 'classnames';
import { ClassValue }                                from 'classnames/types';
import { Size, Position }                            from '../../types/componentPropTypes';
import { FlexAlign, FlexJustify, NumberRange0to100 } from '../../types/componentPropTypes';

export interface FlexItemProps {
	className?: ClassValue,
	contentClasses?: ClassValue,
	style?: object,
	basis?: NumberRange0to100,
	noGrow?: boolean,
	noShrink?: boolean,
	position?: Position,
	align?: FlexAlign,
	justify?: FlexJustify,
	preContent?: ReactNode,
	postContent?: ReactNode,
	overflow?: false,
	overflowSize?: Size.SM | Size.MD | Size.LG,
	overflowAxis?: 'x' | 'y',
	
	[ additionalProps: string ]: any
}

const defaultProps: FlexItemProps = {
	className:      null,
	style:          null,
	contentClasses: null,
	basis:          null,
	noGrow:         null,
	noShrink:       null,
	position:       null,
	align:          null,
	justify:        null,
	preContent:     null,
	postContent:    null,
	overflow:       false,
	overflowSize:   null,
	overflowAxis:   'y',
};

const FlexItem: FC<FlexItemProps> = ( props ) => {
	
	let { children, basis, noGrow, noShrink }    = props,
	    { position, justify, align }             = props,
	    { style, preContent, postContent }       = props,
	    { overflow, overflowSize, overflowAxis } = props;
	
	let containerClasses = classNames(
		'flexitem',
		{
			'position--relative':                 !position,
			[ `position--${ position }` ]:        position,
			[ `flexitem--basis-${ basis }` ]:     basis,
			[ `flexitem--no-grow` ]:              noGrow,
			[ `flexitem--no-shrink` ]:            noShrink,
			[ `flexitem--align-${ align }` ]:     align,
			[ `flexitem--justify-${ justify }` ]: justify,
		},
		props.className,
	);
	
	let contentClasses = classNames(
		props.contentClasses
	);
	
	let overflowClasses = classNames( {
		[ `overflow-content--${ overflowAxis }` ]: overflow,
		[ `overflow-content--${ overflowSize }` ]: overflow && overflowSize
	} );
	
	return (
		<div className={ containerClasses } style={ style }>
			
			{ preContent }
			
			{ contentClasses ?
			  (
				  <div className={ contentClasses }>
					
					  { overflowClasses ? <div className={ overflowClasses }> { children }</div> : children }
				
				  </div>
			
			  ) : children }
			
			{ postContent }
		
		</div>
	);
};

FlexItem.defaultProps = defaultProps;

export { FlexItem };
